<script lang="ts" setup>
  defineEmits<{ (e: "retry"): void }>();
</script>

<template>
  <UModal :default-open="true">
    <template #title>
      <h1>{{ $t("errors.offline.files-upload-failed-title") }}</h1>
    </template>
    <template #body>
      <div class="space-y-4">
        <p class="text-sm text-gray-500">
          {{ $t("errors.offline.files-upload-failed-message") }}
        </p>
        <UButton
          :label="$t('actions.retry')"
          variant="outline"
          icon="heroicons-arrow-path"
          class="mx-auto flex"
          @click="() => $emit('retry')"
        />
      </div>
    </template>
  </UModal>
</template>

<style></style>
